import { Component } from '@angular/core';

import { ApParagraphSkeletonComponent, ApInputSkeletonComponent, ApButtonSkeletonComponent } from '@ap/skeleton';

/**
 * @ngdoc component
 * @name ApBrowserSkeletonComponent
 */
@Component({
    selector: 'ap-browser-selector-skeleton',
    standalone: true,
    templateUrl: './browser-selector-skeleton.component.html',
    styleUrls: ['./browser-selector-skeleton.component.scss'],
    imports: [ApParagraphSkeletonComponent, ApInputSkeletonComponent, ApButtonSkeletonComponent]
})
export class ApBrowserSelectorSkeletonComponent {}
